import { createSlice } from "@reduxjs/toolkit";
import { driverApi } from "@/redux/apis";
import { driverPayoutApi } from "@/redux/apis/driver/driverPayoutApi";
import { pageState } from "@/redux/types";
import { DriverState, fleetOptionsInitialState, offloadOptionsInitialState } from "./types";

const initialState: DriverState = {
  fleet: {
    drivers: [],
    page: pageState,
    options: fleetOptionsInitialState,
  },
  offload: {
    drivers: [],
    page: pageState,
    options: offloadOptionsInitialState,
  },
  payout: {
    payouts: [],
    page: pageState,
  },
};

export const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(driverApi.endpoints.getFleetOptions.matchFulfilled, (state, { payload }) => {
      const { options } = payload.data;
      state.fleet.options = options;
    });
    builder.addMatcher(driverApi.endpoints.getOffloadDrivers.matchFulfilled, (state, { payload }) => {
      const { drivers, page } = payload.data;
      state.offload.drivers = drivers;
      state.offload.page = page;
    });
    builder.addMatcher(driverApi.endpoints.getOffloadOptions.matchFulfilled, (state, { payload }) => {
      const { options } = payload.data;
      state.offload.options = options;
    });
    builder.addMatcher(driverPayoutApi.endpoints.getPayouts.matchFulfilled, (state, { payload }) => {
      state.payout = payload.data;
    });
  },
});

export default driverSlice.reducer;
